import { render, staticRenderFns } from "./SocketDetails.vue?vue&type=template&id=3c0dcfcd&scoped=true"
import script from "./SocketDetails.vue?vue&type=script&lang=js"
export * from "./SocketDetails.vue?vue&type=script&lang=js"
import style0 from "./SocketDetails.vue?vue&type=style&index=0&id=3c0dcfcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0dcfcd",
  null
  
)

export default component.exports